import Vue from "vue";
import Router from "vue-router";
import {ENV} from "@/core/config/env";
import notification from "@/router/notification";
import authority from "@/router/authority";
import voucher from "@/router/voucher";
import confirm from "@/router/confirm";
import subcontractor from "@/router/subcontractor";
import business from "@/router/business";
import budget from "@/router/budget";
import routeTenant from "@/core/services/routeTenant.service"
Vue.use(Router);

const baseUrlTenant = routeTenant.routeBaseConfig();
const tenant = routeTenant.getTenant();

export default new Router({
    mode: "history",
    routes: [
        {
            path: baseUrlTenant,
            component: () => import("@/view/layout/Layout"),
            children: [
                {
                    path: "dashboard",
                    name: "dashboard",
                    component: () => import("@/view/pages/Dashboard.vue")
                }
            ]
        },
        {
            path: baseUrlTenant,
            component: () => import("@/view/layout/Layout"),
            children: [
                {
                    path: "update-password",
                    name: "update-password",
                    component: () => import("@/view/pages/user/UpdatePassword.vue")
                }
            ]
        },
        {
            path: baseUrlTenant,
            redirect: tenant ? `${baseUrlTenant}/top` : "/404",
            component: () => import("@/view/layout/Layout"),
            children: [
                {
                    path: "top",
                    name: "top",
                    component: () => import("@/view/pages/Top")
                }
            ]
        },
        {
            path: baseUrlTenant,
            name: "account",
            component: () =>
                import("@/view/layout/Layout"),
            children: [
                {
                    path: "list",
                    name: "list-account",
                    component: () => import("@/view/pages/list_account/Index.vue")

                }
            ]
        },
        {
            path: baseUrlTenant,
            component: () => import("@/view/pages/auth/LayoutAuth.vue"),
            children: [
                {
                    name: "forgot-password",
                    path: "forgot-password",
                    component: () => import("@/view/pages/auth/ForgotPassword.vue")
                },
                {
                    name: "reset-password",
                    path: "change-password",
                    component: () => import("@/view/pages/auth/ResetPassword.vue")
                }

            ]
        },
        {
            path: baseUrlTenant,
            component: () => import("@/view/pages/auth/login_pages/Login-1"),
            children: [
                {
                    name: "login",
                    path: "login",
                    component: () => import("@/view/pages/auth/login_pages/Login-1")
                },
                {
                    name: "register",
                    path: "register",
                    component: () => import("@/view/pages/auth/login_pages/Login-1")
                },
            ]
        },
        ...notification,
        ...voucher,
        ...authority,
        ...confirm,
        ...subcontractor,
        ...business,
        ...budget,
        {
            // the 404 route, when none of the above matches
            path: ENV.BASE_URL + '/404',
            name: "404",
            component: () => import("@/view/pages/error/Error-1.vue")
        }
    ]
});
